import * as React from 'react';

import { useTrack } from '@blockworks/platform/services/analytics';

const useAnalyticsReadTracker = (eventName: string, parameters: any | null, uniqueKey: string) => {
    const track = useTrack();
    const readTracked: string[] = [];
    const priceOpenedAt: number = React.useMemo(() => new Date().getTime(), [uniqueKey]);
    const trackingData = React.useMemo(() => parameters, [parameters]);
    const observer: any = React.useRef();

    return React.useCallback(
        (node: any) => {
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(data => {
                if (trackingData === null) {
                    return;
                }

                if (data[0]?.isIntersecting && !readTracked.includes(trackingData.title)) {
                    readTracked.push(uniqueKey);
                    track(eventName, {
                        ...trackingData,
                        readingTime: (new Date().getTime() - priceOpenedAt) / 1000,
                    });
                }
            });
            if (node) observer.current.observe(node);
        },
        [trackingData],
    );
};

export default useAnalyticsReadTracker;
